import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentHistoryComponent } from './payment-history.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { ApiClient } from '../core/api-client.service';
import { MbscModule } from '@mobiscroll/angular';



@NgModule({
  declarations: [
    PaymentHistoryComponent
  ],
  imports: [
    CommonModule
    , BrowserModule
    , FormsModule
    , ReactiveFormsModule 
    , NgbPaginationModule
    , MbscModule
  ],
  providers: [ApiClient],
})
export class PaymentHistoryModule { }
